import styles from './Shifts.module.css';

import React from 'react';

import Button from '@mui/material/Button';

import Copy from '@mui/icons-material/FileCopy';
import Delete from '@mui/icons-material/Delete';
import Undo from '@mui/icons-material/Undo';

import TablePagination from '@mui/material/TablePagination';
import Divider from '@mui/material/Divider';

export const ShiftsFooter = ({ readOnly, paginationInfo, undo, rowsPerPage, onSetPage, onRowsPerPageChange, onCopyShifts, onRemoveShifts, onUndo, disableCopyRemove }) => {
    const [ page, setPage ] = React.useState(1);

    const handlePageChange = (event, newPage) => {
        setPage(newPage + 1); // Convert 0-based to 1-based
        onSetPage(newPage + 1);
    };

    const handleRowsPerPageChange = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        onRowsPerPageChange(newRowsPerPage);
        setPage(1); // Reset to first page when page size changes
    };
    
    return (
        <div className={ styles.footer }>
            { !readOnly ? <div className={ styles.actions }>
                <Button variant='outlined' color='primary' onClick={ onCopyShifts } disabled={ disableCopyRemove } startIcon={ <Copy /> }>Copy</Button>
                <Button variant='outlined' color='error' onClick={ onRemoveShifts } disabled={ disableCopyRemove } startIcon={ <Delete /> }>Remove</Button>

                <Divider orientation="vertical" flexItem sx={ { mx: 1 } } />

                <Button variant='outlined' color='secondary' onClick={ onUndo } disabled={ !undo } startIcon={ <Undo /> }>Undo</Button>
            </div> : <span>&nbsp;</span> }

            <div className={ styles.page }>
                <TablePagination
                    component="div"
                    count={ paginationInfo.totalShifts }
                    page={ page - 1 } // Convert 1-based to 0-based
                    onPageChange={ handlePageChange }
                    rowsPerPage={ rowsPerPage }
                    rowsPerPageOptions={ [10, 25, 50, 100] }
                    onRowsPerPageChange={ handleRowsPerPageChange }
                    size="small"
                    sx={{
                        '& .MuiTablePagination-toolbar': {
                            minHeight: 'auto',
                            paddingLeft: 1,
                            paddingRight: 1,
                        },
                        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                            fontSize: '0.875rem',
                        },
                        '& .MuiTablePagination-actions': {
                            marginLeft: 1,
                        },
                    }}
                />
            </div>
        </div>
    );
};